const initialState = {
  loading: false,
  success: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'RESET_PASSWORD_REQUEST': {
      return { ...initialState, loading: true };
    }
    case 'RESET_PASSWORD_SUCCESS': {
      return { ...state, success: true, loading: false };
    }
    case 'RESET_PASSWORD_FAILURE': {
      return { ...state, error: action.error, loading: false };
    }
    default:
      return state;
  }
}
